import { render, staticRenderFns } from "./DraggableTaskList.html?vue&type=template&id=fdbcd4b6&scoped=true&"
import script from "./DraggableTaskList.vue?vue&type=script&lang=js&"
export * from "./DraggableTaskList.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTaskList.scss?vue&type=style&index=0&id=fdbcd4b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbcd4b6",
  null
  
)

export default component.exports